const ProgressBar = ({ value, total = 10 }) => {
  const progressPercentage = (value / total) * 100;

  return (
    <div className="flex flex-1 items-center">
      <div className="relative w-full h-[6px] bg-[#ECECEC] rounded-full">
        <div
          className="absolute top-0 left-0 h-[6px] bg-slate-600 rounded-full"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
